/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { chevronDown } from '../../assets/images/formAfterSignUp';
import { OptionType, TStep3Branch } from '../../types';
import styles from './dropdown.module.css';

type TProps = {
  placeholder: string;
  options: OptionType[] | any[];
  label?: string;
  className?: string;
  labelStyles?: string;
  SelectedValueStyles?: string;
  setSelectedOption?: React.Dispatch<React.SetStateAction<OptionType>> | any;
  width?: string;
  borderColor?: string;
  placeholderFont?: string;
  isLoading?: boolean;
  onChange?: (e: any) => void;
  value?: any;
  placeholderColor?: string;
  req?: boolean;
  subLabel?: string;
  required?: boolean;
  hideSearchBar?: boolean;
  newDetails?: TStep3Branch;
  hideStar?: boolean;
};

function Dropdown({
  options,
  placeholder,
  setSelectedOption,
  className,
  label,
  labelStyles,
  SelectedValueStyles,
  width = 'w-72 sm:w-96',
  borderColor = 'border-[#f8b400]',
  placeholderFont,
  isLoading,
  required,
  onChange,
  value,
  placeholderColor,
  req,
  subLabel,
  newDetails,
  hideSearchBar = false,
  hideStar = false,
}: TProps) {
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const handler = () => setShowMenu(false);
    window.addEventListener('click', handler);

    return () => {
      window.removeEventListener('click', handler);
    };
  });

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowMenu(!showMenu);
  };
  const getDisplay = () => {
    return placeholder;
  };

  const [selectedOption, setSelected] = useState<OptionType | null>(value);
  const [filteredList, setFilteredList] = useState<any>();
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    if (options) {
      setFilteredList(options);
    }
  }, [options]);
  useUpdateEffect(() => {
    onChange?.(selectedOption?.name || selectedOption?.value);
  }, [selectedOption]);

  useEffect(() => {
    const newList = options?.filter(
      (option) =>
        option?.label?.toString()?.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1,
    );

    setFilteredList(newList);
  }, [searchQuery]);

  return (
    <>
      <label className={`${labelStyles} flex`}>
        <div className='flex flex-col'>
          <div className='flex flex-row'>
            {label} {required && !hideStar && <span className='text-[red] ml-2'>*</span>}
          </div>
          <span className='text-[10px] text-[grey]'>{subLabel ?? null}</span>
        </div>
        {req && <div className=' block md:hidden text-[#F51010] '>*</div>}
      </label>
      <div className={`${[styles.dropdownContainer, width, borderColor].join(' ')}  ${className}`}>
        <div
          className={`${styles.dropdownInput} focus:border-[#f8b400] cursor-pointer`}
          onClick={(e) => handleClick(e)}
        >
          <div
            className={`${
              (styles.dropdownSelectedValue, placeholderFont, placeholderColor)
            } ${SelectedValueStyles} font-normal text-[${placeholderFont ?? '14px'}] truncate`}
            style={hideSearchBar ? { marginRight: '10px' } : {}}
          >
            {value && getDisplay() ? getDisplay() : value || (!value && getDisplay())}

            {/* {isLoading && 'Loading'} */}
          </div>
          <div className={styles.dropdownTools}>
            <div className={[styles.dropdownIcon, hideSearchBar && 'h-4 w-4'].join(' ')}>
              <img
                src={chevronDown}
                alt='arrow-down'
                className={['w-3 h-2', hideSearchBar && 'h-2 w-2'].join(' ')}
              />
            </div>
            {showMenu && (
              <div className={styles.dropdownMenu} style={hideSearchBar ? { width: '100%' } : {}}>
                {!isLoading && filteredList && !hideSearchBar && (
                  <div>
                    <input
                      // className={styles.dropdownItem}
                      placeholder='Type to search'
                      onChange={(e) => setSearchQuery(e.target.value)}
                      autoFocus
                      style={{
                        width: '100%',
                        height: '40px',
                        outline: 'none',
                        border: '1px solid grey',
                        paddingLeft: '10px',
                        borderRadius: '5px',
                      }}
                    />
                  </div>
                )}
                {!isLoading && filteredList
                  ? filteredList?.map((option: any, i: any) => (
                      <div
                        key={i}
                        className={styles.dropdownItem}
                        onClick={() => {
                          setSelectedOption(option);
                          setSelected(option);
                          setSearchQuery('');
                        }}
                      >
                        {option?.name || option?.label}
                      </div>
                    ))
                  : isLoading && <div className={styles.dropdownItem}>loading...</div>}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Dropdown;
